/**
 * Chat participant dialogs for adding members and leaving conversations.
 */
import type { ReactNode } from 'react'

import { AddParticipantDialog } from '@/components/chat/add-participant-dialog.organism'
import { ConfirmDialog } from '@/components/molecules/confirm-dialog.molecule'

import type { UseChatParticipantActionsReturn } from './use-chat-participant-actions.hook'

interface ChatParticipantDialogsProps {
  participantActions: UseChatParticipantActionsReturn
}

export const ChatParticipantDialogs = ({
  participantActions,
}: ChatParticipantDialogsProps): ReactNode => (
  <>
    <AddParticipantDialog
      isOpen={participantActions.isAddParticipantDialogOpen}
      onOpenChange={participantActions.setAddParticipantDialogOpen}
      memberList={participantActions.availableMemberList}
      onMemberSelect={participantActions.handleAddParticipant}
      isLoading={participantActions.isMembersLoading}
    />

    <ConfirmDialog
      isOpen={participantActions.isLeaveDialogOpen}
      onOpenChange={participantActions.setLeaveDialogOpen}
      title="Leave Conversation"
      description="Are you sure you want to leave this conversation? You will no longer receive messages or be able to participate."
      confirmLabel="Leave"
      cancelLabel="Cancel"
      onConfirm={participantActions.handleLeaveConversation}
      variant="destructive"
    />
  </>
)
